import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../js/void.mjs';
import { IllegalArgumentException2asla15b5jaob as IllegalArgumentException } from '../exceptions.mjs';
import { getProgressionLastElement2w30kdy2w5nkt as getProgressionLastElement } from '../internal/progressionUtil.mjs';
import {
  IntProgressionIterator2ovd1ctrmu51n as IntProgressionIterator,
  CharProgressionIterator34nq4ujuknl08 as CharProgressionIterator,
} from './ProgressionIterators.mjs';
import {
  Char__toInt_impl_vasixdnyockrdnmht5 as Char__toInt_impl_vasixd,
  Char__compareTo_impl_ypi4mb28h1l6umahrlb as Char__compareTo_impl_ypi4mb,
  toString22rbkbhdb5cl2 as toString,
} from '../Char.mjs';
import { numberToChar93r9buh19yek as numberToChar } from '../js/numberConversion.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      p3(rangeStart, rangeEnd, step) {
        return new (IntProgression())(rangeStart, rangeEnd, step);
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  return Companion_instance;
}
var IntProgressionClass;
function IntProgression() {
  if (IntProgressionClass === VOID) {
    class $ {
      constructor(start, endInclusive, step) {
        if (step === 0)
          throw IllegalArgumentException().n2('Step must be non-zero.');
        if (step === -2147483648)
          throw IllegalArgumentException().n2('Step must be greater than Int.MIN_VALUE to avoid overflow on negation.');
        this.q3_1 = start;
        this.r3_1 = getProgressionLastElement(start, endInclusive, step);
        this.s3_1 = step;
      }
      p1() {
        return new (IntProgressionIterator())(this.q3_1, this.r3_1, this.s3_1);
      }
      n1() {
        return this.s3_1 > 0 ? this.q3_1 > this.r3_1 : this.q3_1 < this.r3_1;
      }
      equals(other) {
        var tmp;
        if (other instanceof IntProgression()) {
          tmp = this.n1() && other.n1() || (this.q3_1 === other.q3_1 && this.r3_1 === other.r3_1 && this.s3_1 === other.s3_1);
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return this.n1() ? -1 : imul(31, imul(31, this.q3_1) + this.r3_1 | 0) + this.s3_1 | 0;
      }
      toString() {
        return this.s3_1 > 0 ? '' + this.q3_1 + '..' + this.r3_1 + ' step ' + this.s3_1 : '' + this.q3_1 + ' downTo ' + this.r3_1 + ' step ' + (-this.s3_1 | 0);
      }
    }
    initMetadataForClass($, 'IntProgression');
    IntProgressionClass = $;
  }
  return IntProgressionClass;
}
var CompanionClass_0;
function Companion_0() {
  if (CompanionClass_0 === VOID) {
    class $ {}
    initMetadataForCompanion($);
    CompanionClass_0 = $;
  }
  return CompanionClass_0;
}
var Companion_instance_0;
function Companion_getInstance_0() {
  return Companion_instance_0;
}
var CharProgressionClass;
function CharProgression() {
  if (CharProgressionClass === VOID) {
    class $ {
      constructor(start, endInclusive, step) {
        if (step === 0)
          throw IllegalArgumentException().n2('Step must be non-zero.');
        if (step === -2147483648)
          throw IllegalArgumentException().n2('Step must be greater than Int.MIN_VALUE to avoid overflow on negation.');
        this.so_1 = start;
        var tmp = this;
        // Inline function 'kotlin.code' call
        var tmp_0 = Char__toInt_impl_vasixd(start);
        // Inline function 'kotlin.code' call
        var tmp$ret$1 = Char__toInt_impl_vasixd(endInclusive);
        tmp.to_1 = numberToChar(getProgressionLastElement(tmp_0, tmp$ret$1, step));
        this.uo_1 = step;
      }
      p1() {
        return new (CharProgressionIterator())(this.so_1, this.to_1, this.uo_1);
      }
      n1() {
        return this.uo_1 > 0 ? Char__compareTo_impl_ypi4mb(this.so_1, this.to_1) > 0 : Char__compareTo_impl_ypi4mb(this.so_1, this.to_1) < 0;
      }
      equals(other) {
        var tmp;
        if (other instanceof CharProgression()) {
          tmp = this.n1() && other.n1() || (this.so_1 === other.so_1 && this.to_1 === other.to_1 && this.uo_1 === other.uo_1);
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        var tmp;
        if (this.n1()) {
          tmp = -1;
        } else {
          // Inline function 'kotlin.code' call
          var this_0 = this.so_1;
          var tmp$ret$0 = Char__toInt_impl_vasixd(this_0);
          var tmp_0 = imul(31, tmp$ret$0);
          // Inline function 'kotlin.code' call
          var this_1 = this.to_1;
          var tmp$ret$1 = Char__toInt_impl_vasixd(this_1);
          tmp = imul(31, tmp_0 + tmp$ret$1 | 0) + this.uo_1 | 0;
        }
        return tmp;
      }
      toString() {
        return this.uo_1 > 0 ? toString(this.so_1) + '..' + toString(this.to_1) + ' step ' + this.uo_1 : toString(this.so_1) + ' downTo ' + toString(this.to_1) + ' step ' + (-this.uo_1 | 0);
      }
    }
    initMetadataForClass($, 'CharProgression');
    CharProgressionClass = $;
  }
  return CharProgressionClass;
}
//region block: init
Companion_instance = new (Companion())();
Companion_instance_0 = new (Companion_0())();
//endregion
//region block: exports
export {
  Companion_instance as Companion_instance1u0qit77fg3ry,
  CharProgression as CharProgression45cqq4g7w3uj,
  IntProgression as IntProgressionfaq59u1bhfih,
};
//endregion

//# sourceMappingURL=Progressions.mjs.map
